module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label class="warranted-checkbox checkbox">\n    <div class="warranted-checkbox__wrapper">\n        <input type="checkbox" data-layer-name="Высокая вероятность подтверждения">\n        <div class="checkboxStyle"><span class="icon icon-i16_check_thin"></span></div>\n        <span class="warranted-checkbox__name">\n            Прямые перелёты\n        </span>\n    </div>\n</label>\n';
}
return __p;
};
